import { AuthActions, AuthSelector } from '@/store/auth';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
export const StripeCheckoutSuccess = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(AuthSelector.getLoading);
    const handleContinue = async () => {
        await dispatch(AuthActions.removeSessionAsync());
        navigate('/signupSuccess', { replace: true });
    };
    return (React.createElement(Box, { textAlign: "center", mt: 4 },
        React.createElement(CheckCircleIcon, { sx: { fontSize: 80, color: 'success.main' } }),
        React.createElement(Typography, { variant: "h5", fontWeight: 600, mt: 2 }, "You are all set up!"),
        React.createElement(Button, { variant: "contained", disableElevation: true, color: "primary", loading: loading, loadingPosition: "center", sx: {
                mt: 2,
                px: 2,
                fontWeight: 600,
                borderRadius: '12px',
                textTransform: 'none',
            }, onClick: handleContinue }, "Continue to App")));
};
